module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-row', {
    staticClass: "noprint",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "headline font-weight-light"
  }, [_vm._v("\n            This tag represents this category.\n          ")])])], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "wrap": "",
      "id": "printablediv"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "text-xs-center display-2"
  }, [_vm._v("\n          " + _vm._s(_vm.codeValue) + "\n          ")])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('canvas', {
    ref: "qr"
  })])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "noprint",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Code Size",
      "items": _vm.sizes,
      "chips": ""
    },
    model: {
      value: (_vm.size),
      callback: function($$v) {
        _vm.size = $$v
      },
      expression: "size"
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a211aa34","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/QRHolder.vue
// module id = 411
// module chunks = 1